import { Controller } from "@hotwired/stimulus"

// Keeps the message list scrolled to the newest message: on open (so a thread shows its latest
// reply) and whenever a message is appended (the turbo_stream reply, or a live broadcast).
export default class extends Controller {
  connect() {
    this.scrollToBottom()
    this.observer = new MutationObserver(() => this.scrollToBottom())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
